import type { TOC } from '@ember/component/template-only';
import { on } from '@ember/modifier';
import WrButton from '../button.gts';

export interface Signature {
  Element: HTMLElement;
  Args: {
    /** Called when the user clicks the close button */
    onClose: () => void;
    /** The id of the title, for the `aria-labelledby` of the dialog */
    titleId?: string;
  };
  /** The title of the modal */
  Blocks: { default: [] };
}

/**
 * The header of a modal: the title on the Wiser background image, and a close
 * button. WrModalContent uses it; use it too in a modal that is not a
 * WrModalContent.
 */
const WrModalHeader: TOC<Signature> = <template>
  <header
    class='bg-header flex items-center justify-between bg-cover bg-center pr-3'
    ...attributes
  >
    <h1
      id={{@titleId}}
      class='text-h2 px-3 py-2 font-sans font-medium text-white'
    >{{yield}}</h1>
    <WrButton
      @icon='Close'
      @variant='inverted-link'
      aria-label='Fermer'
      {{on 'click' @onClose}}
    />
  </header>
</template>;

export default WrModalHeader;
